import { get, set, del } from "idb-keyval";

export interface PendingUpload {
  key: string;
  blob: Blob;
  folder: string;
  projectID: string;
  extension: string;
  isPublic: boolean;
}

const PENDING_UPLOADS_KEY = "pending-upload-queue";

export const useImageStoreLocal = () => {
  const getImage = async (key: string): Promise<string | null> => {
    const blob = await get(key);
    if (!blob) return null;
    return URL.createObjectURL(blob);
  };

  const saveImage = async (key: string, data: Blob): Promise<void> => {
    await set(key, data);
  };

  const removeImage = async (key: string): Promise<void> => {
    await del(key);
  };

  // Pending upload queue management
  const getPendingUploads = async (): Promise<PendingUpload[]> => {
    const queue = await get<PendingUpload[]>(PENDING_UPLOADS_KEY);
    return queue || [];
  };

  const savePendingUpload = async (upload: PendingUpload): Promise<void> => {
    const queue = await getPendingUploads();
    // Check if upload with same key already exists
    const existingIndex = queue.findIndex((u) => u.key === upload.key);
    if (existingIndex >= 0) {
      // Update existing
      queue[existingIndex] = upload;
    } else {
      // Add new
      queue.push(upload);
    }
    await set(PENDING_UPLOADS_KEY, queue);
  };

  const removePendingUpload = async (key: string): Promise<void> => {
    const queue = await getPendingUploads();
    const filtered = queue.filter((u) => u.key !== key);
    await set(PENDING_UPLOADS_KEY, filtered);
  };

  const clearPendingUploads = async (): Promise<void> => {
    await del(PENDING_UPLOADS_KEY);
  };

  return {
    getImage,
    saveImage,
    removeImage,
    getPendingUploads,
    savePendingUpload,
    removePendingUpload,
    clearPendingUploads,
  };
};
